<template>
  <div class="address">
    <div>
      <div class="header">
        <div class="container">
          <img @click="goHome()" class="logo" src="../assets/logo.png" alt="" />
          <span class="float-right header-height ts-stake" @click="goStake()"
            >TS Stake</span
          >
        </div>
      </div>

      <div class="result">
        <div class="container">
          <h2>Result</h2>
          <div class="result-content">
            <div v-if="isFiltered">
              <div class="tip-warning">
                We have received your feedback that your private key or mnemonic
                has been leaked. To protect your assets’ safety, we stop your
                refund at this time, we will help you get your refund safely as
                soon as possible. <br />
                Please always refer to official announcements.
              </div>
            </div>

            <div v-else-if="hasData === true">
              <div>
                <label for="">Address:</label>
                <span class="data-address">{{ address }}</span>
              </div>
              <div>
                <label>Hacked Assets:</label>
                <span class="data-tokens">{{ tokensStr }}</span>
              </div>
              <div>
                <label for="">Refunded Tokens:</label>
                <span class="data-returned"
                  >{{ refundTokenStr }} ({{ claimChain.toUpperCase() }})
                </span>
                <button v-if="claiming" class="confirm-btn btn-sm disabled">
                  Claiming
                </button>
                <button
                  v-else-if="claimed === true"
                  class="confirm-btn btn-sm disabled"
                >
                  Claimed ({{ isNoTs ? "80%" : "68%" }})
                </button>
                <button
                  v-else-if="claimed === false"
                  class="confirm-btn btn-sm"
                  @click="claim()"
                >
                  Claim
                </button>
              </div>

              <div>
                <label for=""></label>
                <span class="data-returned"
                  >{{ refundTokenStr2 }} ( BSC )
                </span>
                <button v-if="claiming" class="confirm-btn btn-sm disabled">
                  Claiming
                </button>
                <button
                  v-else-if="claimed2 === true"
                  class="confirm-btn btn-sm disabled"
                >
                  Claimed ({{ isNoTs ? "20%" : "15%" }})
                </button>
                <button
                  v-else-if="claimed2 === false"
                  class="confirm-btn btn-sm"
                  @click="claim2()"
                >
                  Claim
                </button>
              </div>
              <div v-if="!isNoTs">
                <label for=""></label>
                <span class="data-returned"
                  >{{ refundTokenStr3 }} ( BSC )
                </span>
                <button v-if="claiming" class="confirm-btn btn-sm disabled">
                  Claiming
                </button>
                <button
                  v-else-if="claimed3 === true"
                  class="confirm-btn btn-sm disabled"
                >
                  Claimed (17%)
                </button>
                <button
                  v-else-if="claimed3 === false"
                  class="confirm-btn btn-sm"
                  @click="claim3()"
                >
                  Claim
                </button>
              </div>

              <div class="tip-error">
                Please note that all news is subject to the official
                announcement only, and do not provide the mnemonic or private
                key to others at any time
              </div>
            </div>
            <div v-else-if="hasData === false">
              <div class="tip-warning">
                We cannot find any related information about the address you
                input, {{ address }}. Your address has nothing related to the
                Transit Hacking Event.
              </div>
              <div class="self-check">
                Please self-check your wallet as the followings:

                <ul>
                  <li>
                    ① If you downloaded your wallet from official links or not.
                    Official website
                    <a href="https://tokenpocket.pro"
                      >https://tokenpocket.pro/</a
                    >
                  </li>
                  <li>
                    ② Have you communicated with the self-proclaimed "official
                    customer service" and leaked wallet mnemonics or private
                    keys
                  </li>
                  <li>
                    ③ Have you done any approval on third-party website, click
                    here to check your approvals
                  </li>
                  <li>
                    ④ Have you participated any campaigns like "airdrop",
                    "mining" or "high-yield return"
                  </li>
                </ul>
              </div>

              <div class="tip-error">
                Attentions: Transit Official will never contact you first, we
                will never ask for your private keys or mnemonic either! Be wary
                of anyone calling themselves "official customer service", these
                are scammers!
              </div>
            </div>
            <div v-else class="loading">Loading</div>
          </div>
        </div>
      </div>

      <div class="info">
        <div class="container">
          <h2>
            <img class="line" src="../assets/line.png" alt="" />
            Timeline and Progress

            <img class="line" src="../assets/line.png" alt="" />
          </h2>

          <div class="content">
            <div class="current">
              <div class="event-item">
                <span class="decorations">
                  <span class="circle">
                    <img src="../assets/radio.png" alt="" />
                  </span>
                  <span class="link"></span>
                </span>
                <span class="event-time"> Current </span>
                <span class="event-content"
                  >It is still in progress, trying our best to recover more
                  assets for users</span
                >
              </div>
            </div>

            <div class="event-list">
              <div class="event-item" v-for="(event, index) in events">
                <span class="decorations">
                  <span class="circle"> </span>
                  <span class="link" v-if="index < events.length - 1"></span>
                </span>
                <span class="event-time">
                  {{ event.time | timeformat }}
                </span>
                <span class="event-content" v-html="event.event"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Axios from "axios";
import Web3 from "web3";
import _ from "lodash";

const ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "theExecutor",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Receipt",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "Refund",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "previousTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "latestTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "previousPause",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "latestPause",
        type: "bool",
      },
    ],
    name: "SetClaim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SetRefunder",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimPause",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "executor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "refundAsset",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct TransitFinanceRefund.refund",
        name: "asset",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "claimed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "pause",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "setClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct TransitFinanceRefund.refund[]",
        name: "refunds",
        type: "tuple[]",
      },
    ],
    name: "setRefunder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const NO_TS = [
  "0x3dc724419fb75aa5339f7e6cfd2dc6cdbb3e9bb8",
  "0xc781cfed0a403cc5a630923b21ed952c4c552c58",
  "0x592c3daa1a080decb5d1fd70ae45b121bb042568",
  "0xa79a7daf1d909c6fb2da0c7c8bd3a5321fa153e3",
  "0xbb892bdccc64823e6ad9b23a110cd3a22b73c014",
  "0xbcfd92c7df792a22a48d980e46582f65a8760473",
  "0x04fc540093c3486197abaaa556bd1650daed76a4",
  "0x9c2b304c34a321c08c2126d27148b1b980bd6b75",
  "0x9c720818b471d7b462ebe17ca1985df3a5c69a24",
  "0x63a7c6a91db3dcf442cb2cefbeb59d2881b06e4d",
  "0x26378e36041fcefcf58b58aaa2010cdb655843d3",
  "0x9ee68c42b9c97c11fb5f5e04505310b5a8a66201",
  "0x6d9c7b3f9baf1e42327e34ae9f7859f27591a9e2",
  "0x9f8fe5200d0e58acc021cc88c18a65872a3bdc81",
  "0xc8780edcd4ff38dd4c2df80bcad03201aeaa56b7",
  "0x9e5c3acfb93886e652441af2a9b0e8cb2ba84360",
  "0x15df3bd26e87291a0ae2ef09c8f04e82a8969723",
  "0x928a3f61ca8115412ede3e292d3397f931772546",
  "0xee1c71683c309b780232b7650e276d9285233ccc",
  "0x4464b102fe7f754e1df5e7af441fe46019a7c4d9",
  "0xee9f88297c4a69e8be59d0c186f8847a47e3face",
  "0xbeadf1d14da0162176772a13bc52a0ee09d7c6f2",
  "0xf439b40785d483d270865efca100ed793958e784",
  "0xa8dbea47e2b9b61093ef86315ce3c596d9f20100",
  "0xc5e3f9e48bdb23643f8c47c935677468ab5fb1aa",
  "0x637770016d8c574ec1885c309e792967acf081ec",
  "0x1e4956f0a2d7e53f8d9b91299839cd91eb2c37e9",
  "0x0a7981c3b8a196d8398d3931aba27327307792c7",
  "0x237ed60259be9565339d4b8715d731d3bb2f8d2c",
  "0x91bfe4ba91b56eb18077e2960698566fa3d2c089",
  "0x2a97265ee2888f6d8dceb066b6fb4c46f3ad90e5",
  "0xf0fca6f3fe949d6dba1dda7bbb2ce429f6ed004c",
  "0x593909cc2b21d1874f5e4a72def282276764f6a3",
  "0x69ea8ffb8499b78992440712194be3cf151116cf",
  "0x7f53d43fdde6061d7b314b566029fa211e5dbb9c",
  "0xa8ce4e42801bc30c4695042e42f392321a2a5592",
  "0xca6fea3034febd4f22b54445492744451546abf5",
  "0xb015771583a4c977ebb125ed856f44ee7602bf3c",
  "0xbaf40e3b09362e4a4433727a137969f555f53ad2",
  "0x4965d20e5d030cb94eac01e3b737b9cd1c87ee41",
  "0xd2779556a4b2618bb9271cc833551b1675e9d6d1",
  "0x3c2ae8f3a3cf41950981d854c85e1ab202e3ec61",
  "0x847969281746540842dfb11a0aa634f43d582aef",
  "0x5b2933948b43e68111c541032e94525e32c825cb",
  "0x3b50f4df368106be8d6b780a927291a85a007028",
  "0x41e9b85c7a8b8cb66be12dc4251ebd7204a75091",
  "0xd1fa3a63efffb5e6ffe0d5d57a2b9cda2016d84a",
  "0x2b6dc5c84172879bd6db7e016ea02a6d82631c33",
  "0x5e2a50bd59c42e492660729a52139a3cd4770d30",
  "0xa7a1d89914299d05cb3f104be6de22e9a2538c48",
  "0x7d37c6883b12a530836965e2b4f2cd43633dac4b",
  "0x27813538eca7f5d6dc981a3d479546b5aa27d43e",
  "0x84dbe8e4f350b0242a373f9fb43804a8989261bc",
  "0xbe199b0822193343fe37c02676ba22ddc3f97c1b",
  "0xee2bbfb92d250294d134a237a118ac9b7154a44a",
  "0x8f15e0f924a23b4e04bc3c93bb849cbb75f4c2e8",
  "0xa25ac1b6a7f55e8c8bf0217546662093c403ed86",
  "0xbbb710bd3ac8908c2b3670a3f65d1075121ec93c",
  "0x932245785775e8cf7352a5bc686f0e7437206a2e",
  "0x94485f03954d31d83a34eb4d9d8f73c7f602387c",
  "0xed1e6addefa42b0ad41fc62301ad0633b16b7806",
  "0xd0246982f34d47341ec1994e6de354ec2824d270",
  "0xf1499e20548bb74e8599cdd9c7d74912f115925a",
  "0x03cff54f0022c94addb49e1af205c28ff9c6ac0a",
  "0x4320cba337354ff3049d221ca7269788b095aee1",
  "0xf68f2358be24f0fdd6c139f5e26d0c7aec756335",
  "0x2a170d553315c1b5a99ea5e2387b3745ccb17632",
  "0x455ba9ab46ec5ff76d079c8bc9d21c39f59ccfb9",
  "0xcf5c069d48000b2d403c8f460def801f460509e7",
  "0x035ceb3375a745c7072b62190a94a6d5fd2bbe1c",
  "0x062ba5c05ce33247d014ed6f625f273ec7facef8",
  "0x0833c8eae6c58dcfb8e5faa97a9e7bc985c9ac7b",
  "0x09e36c9c12236b99ec1ac55c60d903e52db4232d",
  "0x0cf3cfb3d4419ebd9a99eb62635788b6b8bee1e9",
  "0x0fe064d66a4f574677db45e8b7e1066b0e264318",
  "0x12408bf46f84b6849a675bf2de73453a68ee5dd9",
  "0x12efadebbb4b4eb8bea1420d5689f7554651490f",
  "0x15cc19e2ba61877b02cdd6130032c7e865a091cb",
  "0x1834b8de25c6a87b980cd9c8cc46087bd8e0d840",
  "0x1855255fa8e906efccd813f08320a5c256c00735",
  "0x1d759e6f9ba2c670d83e3339f25d6bde2ad6b75c",
  "0x1e67766d88e21d0fbf1f7f8c80230ef6799c68df",
  "0x1f957d386ce868751f1bab9170c5cc2f60bf9c84",
  "0x1fafd88be338154a8e84d06941aecd432c669f55",
  "0x22169171b406bcab7465b2c16376903982e3a2bb",
  "0x236db7d1520a8a8751092672f3d7f9f4ebca6df0",
  "0x26bda182b48be5b42690efc97eabaf7c566af3ea",
  "0x27f6cf759fd24e99031ccda90291f74ddd97a81d",
  "0x2e916e3a5985556c272540c875af40a2b097a897",
  "0x310d407bcf4b367e593ac993e8c8d690cc1cd16a",
  "0x325c1000e08f988cc8b2f376901e77533fb67c84",
  "0x347cdd6f909047cc7b489ee79816a373ac2058ca",
  "0x351b95b5cf096bee1dafb9d962b95bad999f3b09",
  "0x3b5b1a399d7a3493bda8d4ac910c43708e9be0df",
  "0x43be58c0d2fb6dbdd38c5db6092884e0decc244e",
  "0x46e32aafb2739f3fccb30de8d088f3efb74b3855",
  "0x4dbce96e3d65b1fbfe769515a15e368dd3c1f778",
  "0x50798665e74222f35344a1176c0016b59126f729",
  "0x516c7aeb32c1c98ad88fbdbfcdbc515ceae22c2d",
  "0x541507b1518603a54168652c1b21cd910c291a3a",
  "0x543600bfbf0008edb0f370aef3157f3e290ae603",
  "0x57457810d41d18c02eef988eed288dfc09293dd8",
  "0x57ff6e2d5ccb1a6ec892f9c907744ee10d6c11bf",
  "0x5a8db156be38d227d55f0b7a5c25149b8ecf600d",
  "0x5cf624aaa160e445cd714cb916c0eb572c3aed33",
  "0x5d70df2bd847df4a636535e9557a1f5fee33324d",
  "0x5dfdb1afcbd41c44a696079c175ef146872386b0",
  "0x5e5584321c8d5c34c4180d851d15f1e8704ca927",
  "0x5e617d43f77eaf6c54df71d710d9b1605fdecd4b",
  "0x5fb73f0a49f89d3f35f7bcbe17f809c96ea9d162",
  "0x6098451ff8910a3afeaf041aaeafb387ced0d1ac",
  "0x63e66b1dd9c841058f62d06227ebeccd3b8bcd45",
  "0x6559d8dacd734367d1ee850d7f54d1bddc5ebb0f",
  "0x68fd24a0976730436b67f346e2a591a2bc80819b",
  "0x6b8d744fa83657f9e380c2feb73356dd7754b1c5",
  "0x729b0088bea233bbcb11112c907468549ced063f",
  "0x75ece7eefd69c9cbd56fb880a3416e809e2f13eb",
  "0x780b0e6f18ff02023fb1402a680233961e91f488",
  "0x7ba781e89e9dde2bb92bd0068df11b6576ee89c9",
  "0x7d578674fd721011fc8fd5b5796aaaefe18c5471",
  "0x7e8b52e6bc3f237aa9cbdd3760ed25a71a11587e",
  "0x80d9287df6f794151ef77d7e1f611ec991d718d1",
  "0x8150c915503ad4ed19c89145b5cec16b838ad902",
  "0x83e643195fe16e59102076d8fcaf79feada98d8e",
  "0x852ef0033b1d600a7021c3e6c109ed3659f4741c",
  "0x8581de5694c61a902cd40152e91637a8eba342a7",
  "0x867567c6e3c9225f8a9a81806e6895902719592d",
  "0x897e45379af7b0a01c94e2e391bb1facf787fcab",
  "0x8b54721267e4ba4d3ac82fd6fa8e73fd858bccb6",
  "0x8bd9217f4804ed0f2053adda8a5b5281ce682d9c",
  "0x8c9e4777f949d8ff8e84ff36b3523972b3d5ec03",
  "0x8d3cca479b4114a25c3912fe394f8955feb7d436",
  "0x8fabb26078b5fab0c87b632bd405dae84d755c56",
  "0x8fb9ac98d28f55218d96ec27b2ce694d3cc59056",
  "0x91f8aabfd91a28f6cf215a991cc2f7f4333e6ba9",
  "0x92777d78c3458f19fa3bcd41ad30ad2e4043290e",
  "0x931193948d9b91416f8e19669ec47d54e239e313",
  "0x95e44e0cdef1a3b4f37739abf1b35d94a6ed0896",
  "0x975429cd34e4267923d37c7c11187358328084ad",
  "0x992768746bfdf226b4db4769337fdc1b0e9437c4",
  "0x9e966f65202e7a8d0b1f6b18f383641eb71fc137",
  "0x9f33ea14c0a4c185ae5b2de1352ea3ade5f6c22e",
  "0xa217c94dc6576a1c1c67cd0e785ebaf6390da7c3",
  "0xa30ad8648e252ff76c7650584a4158130c4f66e9",
  "0xa4058b472f699c7124c288db625ac4ac8ee75656",
  "0xa41c1c7442b457a71c7fa3a8ae53d34837df4318",
  "0xa4844a9079f990dc35808960cd558bbfeb68661c",
  "0xa77c530996a593f21094f47967f86c38fee64ff0",
  "0xa7f3c27cc44c10902bd519faa2777b7012cc2e1b",
  "0xa80a0b44b568da7b6d96509d15213b3e9290c432",
  "0xa80a255d01ca518047470c5baf31bfa95d6d6028",
  "0xa8f9f7d3215660aabc4a25e18148230dfe2ca449",
  "0xab0b980e089efa025ac4f0664b729be260075a28",
  "0xab6ac6c4ebe8f3265a6cbd69b237df9be26bde26",
  "0xabc02359ae7b2b8ab3ae8f5133b3cc27f429b253",
  "0xad75b1b881db404d1800fb74a5b2ab9488b094eb",
  "0xaf2efd71f1bf675f6b62a70f4d02c6030f558888",
  "0xb225abf3241286eea88c2e09856c20562de57c0b",
  "0xb63351e6760ca2679fb9c5dc97240f1948bcbb0c",
  "0xb74aaa1504288162084e33858b22391e440a07bb",
  "0xb8618d9d13e2baa299bb726b413ff66418efbbd0",
  "0xb99dffb0b8155f70fcb1b3f58c15b2d3d0081671",
  "0xbbfcb27294e9bdcbc29213f21ce87ebbb23169cc",
  "0xc20f36bcbd544822d1a3c0cbb276cf876f176ae6",
  "0xc271d6561737f3b8729b5517c7c8d668d6c2fc06",
  "0xc2ae0fe58124bbd5a609f8ab65ee9d5737c0af58",
  "0xc3d61f322d71bdc54873939545215179f2ff8507",
  "0xc4a63806e8d2dac7d90f17860f82f724dcfa6c6e",
  "0xcb2e59d938494e46f9d759c937c9913d23ee7bc0",
  "0xcde8373efb5ad965661854b4d56664e88f94766b",
  "0xd03b79abc040ae43f0ff8bb496f0a5f3de688b45",
  "0xd1876422345a802fa17759c7f9dc4c0b5049fc9a",
  "0xd1cb1f4fb110e6c2d39ddf3d646a812f5107d085",
  "0xd1f78608e119c0fa15b977d03bc0f3bce2a3cfd6",
  "0xd2753d49c8f0e8cbff087749c7fac1754d4c215c",
  "0xd28ff14faba968e9247df5531438f758bdd70e88",
  "0xd3740549c317cf68f322a7fbb7e3447f36489d1d",
  "0xd4c282261258cb2b0b31413820795405277036ce",
  "0xd4cff7bf89d5368fc4940e989cf7d0aab76d4970",
  "0xd78159ada80e77406a6311cfc054046c232c454d",
  "0xd993b494ed36a8ba67c617be32ef6de12ed091dc",
  "0xda90012e437e7ceace45c159f5822614e084bef3",
  "0xdb82bd3cf2ee673a95e8e1c73ec9f8b7f2c2dc17",
  "0xdd2a25957fbc2c2d31273cb16b0e0ac5cff34158",
  "0xde2b834889f26739b0ad827874cfe46877fd6624",
  "0xe0d6cbcbcbea56743802d0bf6fb3f275fb9a9f89",
  "0xe26c268479977ce00be3479c7f21e4eb9077e900",
  "0xe61808a0a4307cafa84b2764d0bbb8b6e98f77bd",
  "0xe79dd888b0c25cceb42e7a2872b05e61f26adf64",
  "0xe8fb786b3d66f7e290a6db344791881d0d13f75b",
  "0xe986cb583ad8b35dba65dd33ebd440caa38f5fe0",
  "0xee733ee5336127547ea3c5e5aa021b1a182feae2",
  "0xef1819b24171093da698709fab43e43794bc16bd",
  "0xefe70c33889f0fb89559a6b9adf4d806ca71b530",
  "0xf03bdce0debb1a4adfbaf65782d1ae5422e20b78",
  "0xf0a775c20422441eea04b5b1b2bb3c5b3125c8df",
  "0xf0d98a5d9dc0efd8061b3107baef3d0ca364d854",
  "0xf108df72fd52c4845f367cdbe3bbd26224ca8026",
  "0xf2b7364fad1d3417a0b7924c0103131d578eab8a",
  "0xf9495fe4c0d5fcc64de599b23b386a51fcf2db7b",
];

const FILTERS = [
  "0xaba60c05fd861452f17bbbcc8872ad5b8f26b322",
  "0xEC724eFaDF0565862420764fE046187776DA5F3e",
  "0xd257901DDf335Ea66F5D1ae1878F044429Fe031e",
  "0x903d94b1d76D4308C823DC8940A9ac13dddd75ac",
  "0x0b11d368EAa69682080bc885331D156eBe8E7A6e",
  "0xba179f23f12b24BD7b7E9F8CA3ecE2883875610a",
  "0x38931931c6c042D82180EEa3a95AC6eed498eFD7",
  "0x56aC735d23F8c084f98CD4E84E4dEf402C571aA0",
  "0xd51dAf96Ae30a5e37094193FC4B22569801D737C",
  "0x6198aF69881edC2e80b5b42075010710e61994a4",
  "0x8392A593ae81C6F2979D6fa836075cdd1EBA3D3D",
  "0x63527a2aAda8eD1961449540aAef2Eb6235518aE",
  "0x1F975826bE9c776ADe160e1C834bA9af8d21A7f9",
  "0x9EDee434e656a542Cd33E79053337de46FE0Af4c",
  "0xe9C76c8DCEc54D61134CCBe399861c725D1D5E91",
  "0xb1D39752e17A0C0F4856566C54a0422B280a70BF",
  "0x6238a1af3cFCdCC6e99088d674f17991a9C405c8",
  "0x874c31e1ad5D0Dc22B89956C38dD80C1d8fd5775",
  "0xb1D39752e17A0C0F4856566C54a0422B280a70BF",
  "0x4A52BEA61D761D021c13f33d2B20E1B9339f6f0f",
  "0xD8A2D65251341456b37BeabC22EcF2e61C03D459",
  "0x8749D7B81819Ed544f713838353F2d6a315c1C1c",
  "0xB3215002c9D04F60Ed02A0e2223836CCD9CEc407",
  "0x6a1511CcAf3CF420EEB0d8BE66ECc18416C953f0",
];

const ETH_NODE =
  "https://mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8";
const BSC_NODE = "https://bsc-dataseed3.defibit.io";

const BSC_CONTRACT = "0xc213f258f4142f53d086f9eDb7A36E67eb347F63";

const BSC_CONTRACT_2 = "0x452c452f879256e26ab3b5a447fe29316cf3f687";

const BSC_CONTRACT_3 = "0x58d6bf3589d442bf05b47777eb106ceb0e9abd17";

const ETH_CONTRACT = "0xc213f258f4142f53d086f9edb7a36e67eb347f63";

export default {
  name: "HelloWorld",
  data() {
    return {
      submitting: false,
      events: [],
      address: "",
      addressInfo: "",
      walletAddress: "",
      walletChain: "",
      tokensStr: "",
      hasData: "",
      claimChain: "",
      claimChain2: "bsc",
      claimChain3: "bsc",
      email: "",
      bscWeb3: "",
      isFiltered: false,
      refundTokenStr: "",
      refundTokenStr2: "",
      refundTokenStr3: "",
      claimed: "",
      claimed2: "",
      claimed3: "",
      claiming: false,
      reason: "1",
      isNoTs: false,
      otherReason: "",
      radioData: [
        { value: "1", text: "Data is not correct" },
        {
          value: "2",
          text: "I have already leaked my mnemonic or private keys",
        },
        { value: "3", text: "Others" },
      ],
    };
  },
  filters: {
    timeformat: (val) => {
      return dayjs(val * 1000).format("MM-DD HH:mm");
    },
  },
  created() {
    this.address = this.$route.params.address;

    this.isNoTs = _.includes(NO_TS, this.address.toLowerCase());

    let isFiltered = false;

    FILTERS.forEach((item) => {
      if (this.address.toLowerCase() === item.toLowerCase()) {
        isFiltered = true;
      }
    });

    this.isFiltered = isFiltered;

    this.bscWeb3 = new Web3(BSC_NODE);

    this.ethWeb3 = new Web3(ETH_NODE);

    this.getEvents();
    this.queryAddress();

    this.queryClaim();
    this.queryClaim2();
    this.queryClaim3();
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    goStake() {
      this.$router.push("/stake/ts");
    },
    getEvents() {
      Axios.get("https://progress.transit.finance/finance/progress").then(
        (res) => {
          if (res.status === 200 && res.data) {
            this.events = res.data.data;
          }
        }
      );
    },
    queryAddress() {
      Axios.get(
        "https://progress.transit.finance/finance/check?address=" + this.address
      ).then((res) => {
        if (
          res.status === 200 &&
          res.data &&
          res.data.data &&
          res.data.data.length
        ) {
          this.hasData = true;

          let arr = res.data.data.map((item) => {
            let value =
              +item.value > 100000000
                ? (item.value / 1000000).toFixed(2) + "M"
                : +item.value < 0.01
                ? Number(item.value).toFixed(8)
                : Number(item.value).toFixed(2);

            return value + " " + item.symbol;
          });
          this.tokensStr = arr.join(", ");
        } else {
          console.log(this.hasData);
          if (!this.hasData) {
            this.hasData = false;
          }
        }
      });
    },
    queryClaim3() {
      let bscInstance = new this.bscWeb3.eth.Contract(ABI, BSC_CONTRACT_3);
      bscInstance.methods
        .refundAsset(this.address)
        .call()
        .then((res) => {
          let { token, amount } = res.asset;
          // 通过 amount 判断是否白名单
          if (amount === "0") {
            return;
          }
          this.hasData = true;
          this.claimChain3 = "bsc";

          this.claimed3 = res.claimed;

          amount = parseFloat(amount / Math.pow(10, 18)).toFixed(4);

          let symbol = "TS";

          this.refundTokenStr3 = amount + " " + symbol;
        });
    },
    queryClaim2() {
      let bscInstance = new this.bscWeb3.eth.Contract(ABI, BSC_CONTRACT_2);
      bscInstance.methods
        .refundAsset(this.address)
        .call()
        .then((res) => {
          let { token, amount } = res.asset;
          // 通过 amount 判断是否白名单
          if (amount === "0") {
            return;
          }
          this.hasData = true;
          this.claimChain2 = "bsc";

          this.claimed2 = res.claimed;

          amount = parseFloat(amount / Math.pow(10, 18)).toFixed(4);

          let symbol;

          if (
            token.toLowerCase() === "0x0000000000000000000000000000000000000000"
          ) {
            symbol = "BNB";
          } else if (
            token.toLowerCase() === "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d"
          ) {
            symbol = "USDC";
          } else if (
            token.toLowerCase() === "0xe9e7cea3dedca5984780bafc599bd69add087d56"
          ) {
            symbol = "BUSD";
          } else {
            symbol = token.toLowerCase();
          }

          this.refundTokenStr2 = amount + " " + symbol;
        });
    },
    queryClaim() {
      // bsc
      let bscInstance = new this.bscWeb3.eth.Contract(ABI, BSC_CONTRACT);
      bscInstance.methods
        .refundAsset(this.address)
        .call()
        .then((res) => {
          let { token, amount } = res.asset;
          // 通过 amount 判断是否白名单
          if (amount === "0") {
            return;
          }

          this.hasData = true;

          this.claimChain = "bsc";

          this.claimed = res.claimed;

          amount = parseFloat(amount / Math.pow(10, 18)).toFixed(4);

          let symbol;

          if (
            token.toLowerCase() === "0x0000000000000000000000000000000000000000"
          ) {
            symbol = "BNB";
          } else if (
            token.toLowerCase() === "0x2170ed0880ac9a755fd29b2688956bd959f933f8"
          ) {
            symbol = "ETH";
          } else if (
            token.toLowerCase() === "0x55d398326f99059ff775485246999027b3197955"
          ) {
            symbol = "USDT";
          } else {
            symbol = token.toLowerCase();
          }

          this.refundTokenStr = amount + " " + symbol;
        });

      let ethInstance = new this.ethWeb3.eth.Contract(ABI, BSC_CONTRACT);
      ethInstance.methods
        .refundAsset(this.address)
        .call()
        .then((res) => {
          let { token, amount } = res.asset;
          // 通过 amount 判断是否白名单
          if (amount === "0") {
            return;
          }

          this.hasData = true;

          this.claimChain = "eth";

          this.claimed = res.claimed;

          amount = parseFloat(amount / Math.pow(10, 18)).toFixed(4);

          let symbol;

          if (
            token.toLowerCase() === "0x0000000000000000000000000000000000000000"
          ) {
            symbol = "ETH";
          } else {
            symbol = token.toLowerCase();
          }

          this.refundTokenStr = amount + " " + symbol;
        });
    },
    async claim3() {
      if (!window.ethereum) {
        alert("You need connect you wallet to claim the refund");
        return;
      }

      try {
        if (!this.walletAddress) {
          let walletAddresses = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.walletAddress = walletAddresses[0];
        }

        if (this.walletAddress.toLowerCase() !== this.address.toLowerCase()) {
          alert("Address not match");
          this.submitting = false;
          return;
        }

        if (ethereum.chainId !== "0x38") {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x38",
                chainName: "BNB Chain",
                rpcUrls: [BSC_NODE],
              },
            ],
          });
        }

        let writeWeb = new Web3(window.ethereum);
        this.claiming = true;
        let instance = new writeWeb.eth.Contract(ABI, BSC_CONTRACT_3);
        instance.methods
          .claim()
          .send({ from: this.address })
          .on("transactionHash", (hash) => {
            alert("Success");
          })
          .on("receipt", (receipt) => {
            this.queryClaim3();
            this.claiming = false;
          })
          .on("error", (err) => {
            alert(JSON.stringify(err));
            this.claiming = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    async claim2() {
      if (!window.ethereum) {
        alert("You need connect you wallet to claim the refund");
        return;
      }

      try {
        if (!this.walletAddress) {
          let walletAddresses = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.walletAddress = walletAddresses[0];
        }

        if (this.walletAddress.toLowerCase() !== this.address.toLowerCase()) {
          alert("Address not match");
          this.submitting = false;
          return;
        }

        if (ethereum.chainId !== "0x38") {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x38",
                chainName: "BNB Chain",
                rpcUrls: [BSC_NODE],
              },
            ],
          });
        }

        let writeWeb = new Web3(window.ethereum);
        this.claiming = true;
        let instance = new writeWeb.eth.Contract(ABI, BSC_CONTRACT_2);
        instance.methods
          .claim()
          .send({ from: this.address })
          .on("transactionHash", (hash) => {
            alert("Success");
          })
          .on("receipt", (receipt) => {
            this.queryClaim2();
            this.claiming = false;
          })
          .on("error", (err) => {
            alert(JSON.stringify(err));
            this.claiming = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    async claim() {
      if (!window.ethereum) {
        alert("You need connect you wallet to claim the refund");
        return;
      }

      try {
        if (!this.walletAddress) {
          let walletAddresses = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.walletAddress = walletAddresses[0];
        }

        if (this.walletAddress.toLowerCase() !== this.address.toLowerCase()) {
          alert("Address not match");
          this.submitting = false;
          return;
        }

        if (this.claimChain === "bsc") {
          if (ethereum.chainId !== "0x38") {
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x38",
                  chainName: "BNB Chain",
                  rpcUrls: [BSC_NODE],
                },
              ],
            });
          }

          let writeWeb = new Web3(window.ethereum);
          this.claiming = true;
          let instance = new writeWeb.eth.Contract(ABI, BSC_CONTRACT);
          instance.methods
            .claim()
            .send({ from: this.address })
            .on("transactionHash", (hash) => {
              alert("Success");
            })
            .on("receipt", (receipt) => {
              this.queryClaim();
              this.claiming = false;
            })
            .on("error", (err) => {
              alert(JSON.stringify(err));
              this.claiming = false;
            });
        } else if (this.claimChain === "eth") {
          if (ethereum.chainId !== "0x1") {
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x1",
                  chainName: "Ethereum Mainnet",
                  rpcUrls: [ETH_NODE],
                },
              ],
            });
          }

          let writeWeb = new Web3(window.ethereum);

          let instance = new writeWeb.eth.Contract(ABI, ETH_CONTRACT);
          this.claiming = true;
          instance.methods
            .claim()
            .send({ from: this.address })
            .on("transactionHash", (hash) => {
              alert("Success");
            })
            .on("receipt", (receipt) => {
              this.queryClaim();
              this.claiming = false;
            })
            .on("error", (err) => {
              alert(JSON.stringify(err));
              this.claiming = false;
            });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async sign() {
      if (!window.ethereum) {
        alert("You need connect you wallet to sign the message");
        return;
      }

      this.submitting = true;

      try {
        if (!this.walletAddress) {
          let walletAddresses = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.walletAddress = walletAddresses[0];
        }

        if (this.walletAddress.toLowerCase() !== this.address.toLowerCase()) {
          alert("Address not match");
          this.submitting = false;
          return;
        }

        if (this.email) {
          var pattern =
            /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

          if (!pattern.test(this.email)) {
            alert("Invalid email");
            this.submitting = false;
            return;
          }
        }

        let sig = await ethereum.request({
          method: "personal_sign",
          params: ["Verifying address on transit", this.walletAddress],
        });

        let content = this.radioData[+this.reason - 1].text;
        if (+this.reason === 3) {
          content += ":" + this.otherReason;
        }
        Axios.post("https://progress.transit.finance/finance/report", {
          signature: sig,
          address: this.address,
          email: this.email,
          content: content,
        })
          .then((res) => {
            alert("success");
            this.submitting = false;
          })
          .catch((err) => {
            alert(JSON.stringify(err));
            this.submitting = false;
          });
      } catch (err) {
        this.submitting = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.tip-error {
  background: #ffecec;
  color: #f56459;
  padding: 12px 24px;
  border-radius: 8px;
  margin-top: 24px !important;
}

.tip-warning {
  background: #fef5ee;
  word-break: break-all;
  color: #ff7114;
  padding: 12px 24px;
  border-radius: 8px;
  margin-top: 24px !important;
}

.result {
  text-align: center;

  .loading {
    text-align: center;
    line-height: 200px;
    font-size: 16px;
  }

  .data-address {
    word-break: break-all;
  }

  ul {
    li {
      margin: 8px 0;
    }
  }

  .result-content {
    text-align: left;
    width: 90%;
    max-width: 900px;
    border: 1px solid #e6e8ea;
    border-radius: 16px;
    margin: 24px auto;
    min-height: 200px;
    padding: 24px 32px;
    box-sizing: border-box;

    div {
      margin: 12px 0;
    }

    label {
      display: inline-block;
      vertical-align: middle;
      min-width: 142px;
      color: #9ea0a5;
    }
  }

  .have-question {
    text-align: left;
    width: 90%;
    max-width: 900px;
    // border: 1px solid #e6e8ea;
    border-radius: 16px;
    margin: 24px auto;
    min-height: 200px;
    padding: 24px;
    box-sizing: border-box;

    ul {
      margin: 18px 0;
    }

    li {
      margin: 8px 0;
    }

    h5 {
      margin: 12px 0 8px;
    }

    .other-reason,
    .email {
      max-width: 680px;
      width: 90%;
      border-radius: 8px;
      padding: 10px 16px;
      font-size: 16px;
      border: 2px solid #e6e8ea;
      box-sizing: border-box;
    }
  }

  .self-check {
  }

  .confirm-btn {
    width: 90%;
    max-width: 340px;
    margin: 18px auto;
    padding: 14px;
    background: #3772ff;
    // background: #ddd;
    border: none;
    border-radius: 90px;
    font-weight: bold;
    font-size: 16px;
    color: #fff;

    &.btn-sm {
      width: auto;
      padding: 4px 8px;
      margin: 0;
      margin-left: 8px;
      font-size: 13px;
    }

    &.disabled {
      background: #ddd;
    }
  }

  h2 {
    font-size: 48px;
    margin: 58px 0 34px;
    color: #3a3b3d;
  }
}

@media screen and (max-width: 460px) {
  .result {
    h2 {
      font-size: 24px;
    }

    .email {
      padding: 12px 8px;
      font-size: 14px;
    }
    .confirm-btn {
      padding: 16px;
      font-size: 16px;
    }
  }
}
</style>
